import { useAuthByTokenAuthProviderProviderTypePostMutation, type AuthProvider } from '@shared/api';
import { useAppDispatch, useAppSelector } from '@shared/redux';
import { authActions, authSelectors } from '@shared/redux/ducks/auth';

interface UseAuthToken {
  onSuccess?: () => Promise<void> | void;
}

export const useAuthToken = ({ onSuccess }: UseAuthToken = {}) => {
  const dispatch = useAppDispatch();
  const [authByTokenMutation, { isLoading: isLoadingByToken }] =
    useAuthByTokenAuthProviderProviderTypePostMutation();

  const currentOrganization = useAppSelector(authSelectors.selectCurrentOrganizationInfo);

  const authByToken = async (code: string, providerType: AuthProvider) => {
    try {
      const responseAuthByToken = await authByTokenMutation({
        providerType,
        bodyAuthByTokenAuthProviderProviderTypePost: { code },
      }).unwrap();

      dispatch(authActions.setTokens(responseAuthByToken));

      const organizations = responseAuthByToken.user_info?.organizations;

      if (organizations?.length && !currentOrganization?.id) {
        dispatch(authActions.setCurrentOrganizationInfo(organizations[organizations.length - 1]));
      }

      await onSuccess?.();
    } catch (e) {
      console.error('authByToken error:', e);
      throw e;
    }
  };

  return { authByToken, isLoadingByToken };
};
